import Vue from "vue";
import { UserTokensStore, User } from "@lab/types/users";
import { DailyDataToken } from "@/shared/types/tokens";
import * as api from "../../api/user.tokens.api";
import { update } from "@/shared/api/health.service.api";

const state: UserTokensStore = {
	errorMessage: null,
	isFetching: false,
	lastFetched: null,
	byID: []
};

const getters = {
	get: (state): DailyDataToken[] =>
		state.byID ? Object.values(state.byID) : null,
	fetching: (state) => state.isFetching,
	errorMessage: (state) => state.errorMessage,
	user: (state, getters, rootState, rootGetters): User =>
		rootGetters["userModule/get"] as User
};
const actions = {
	async fetch({ commit, getters }) {
		const user = getters.user;
		commit(`LOAD_START`);
		if (user) {
			const tokens = await api.fetch(user);
			if (tokens) {
				commit("LOAD_LIST_SUCCESS", tokens);
			}
		}
	},
	async create({ commit, getters }) {
		const user = getters.user;
		if (user) {
			const token = await api.create(user);
			commit("LOAD_ITEM_SUCCESS", token);
		}
	},
	async revoke({ commit, getters }, token) {
		const user = getters.user;
		if (user) {
			await api.revoke(user.id, token.id);
			commit("DELETE_ITEM_SUCCESS", token);
		}
	},
	async update({ commit }, token) {
		commit(`LOAD_START`);
		const updated = await api.update(token).catch((error) => {
			commit("LOAD_FAILURE", error);
		});
		commit("LOAD_ITEM_SUCCESS", updated);
	}
};
const mutations = {
	DELETE_ITEM_SUCCESS(state: any, token: DailyDataToken) {
		const { id } = token;
		Vue.delete(state.byID, id);
		state.isFetching = false;
	},
	LOAD_LIST_SUCCESS(state: any, tokens: DailyDataToken[]) {
		const byID = tokens.reduce((acc, val) => {
			acc[val.id] = val;
			return acc;
		}, {});
		Vue.set(state, "byID", byID);
		state.lastFetched = Date.now();
		state.isFetching = false;
	},
	LOAD_ITEM_SUCCESS(state: any, token: DailyDataToken) {
		if (!token) return;
		Vue.set(state.byID, token.id.toString(), token);
		state.isFetching = false;
	},
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	LOAD_FAILURE(state: any, message: string) {
		state.errorMessage = message;
		state.isFetching = false;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
